<template>
  <div
    id="app"
    @keydown.esc="toggleDrop()"
    class="stack stack-xl"
  >
    <div
      v-if="loading"
    >
      <i
        class="fa-sharp fa-solid fa-spinner fa-spin"
      />
    </div>
    <div
      v-else
      class="choose-form stack center"
    >
      <div
        v-if="showatar"
        class="stack stack-s"
      >
        <label
          for="atarNum"
          class="heading-xxs"
        >1. Enter your ATAR score or ECU selection rank</label>
        <input
          id="atarNum"
          ref="atar"
          v-model.number="atarval"
          class="form__input"
          type="text"
          inputmode="decimal"
          @keyup="updateList"
          @keydown="isNumber"
        >
      </div>

      <div
        v-if="showcourses"
        :class="disabled ? 'disabled' : ''"
        :aria-hidden="[disabled]"
        class="stack stack-s"
      >
        <label
          for="studyOptions"
          class="heading-xxs"
        ><span v-if="showatar">2. </span>Type your area of interest here</label>
        <autocomplete
          ref="search"
          :idval="'studyOptions'"
          :pholder="'Filter down your results'"
          :items="filterlist"
          :disabled="disabled"
          @searchVal="searchVal"
        />
      </div>
      <p>
        <a
          href="#"
          class="heading-xxs"
          @click.prevent="reset"
        >
          <i
            class="fa-sharp fa-solid fa-undo-alt icon-inline-start"
          />
          Start again
        </a>
      </p>
    </div>

    <Courses
      :atarval="atarval"
      :showintro="showintro"
      :clist="clist"
    />
  </div>
</template>

<script>
import Autocomplete from './components/Autocomplete.vue'
import Courses from './components/Courses.vue'

export default {
  name: 'App',
  components: {
    Autocomplete,
    Courses
  },
  data () {
    return {
      clist: [],
      fulllist: [],
      filterlist: [],
      atarval: null,
      searchval: '',
      loading: true,
      showintro: true,
      showatar: false,
      showcourses: false,
      firsttime: true,
      aria: false,
      dropclass: '',
      disabled: true,
      persona: 'okATAR',
      happyCourses: [],
      noHappyCourses: [],
      noAtarCourses: []
    }
  },
  created () {
    // get data from funnelback
    const urlVars = this.getUrlVars()
    const storeVar = window.localStorage.getItem('ecu-study-type')
    if (urlVars.context !== undefined) {
      if (urlVars.context === 'noATAR' || urlVars.context === 'reviewATAR') {
        this.persona = urlVars.context
      }
    } else {
      if (storeVar !== null) {
        if (storeVar === 'noATAR' || storeVar === 'reviewATAR') {
          this.persona = storeVar
        }
      }
    }

    this.getData()

    /**
     * Listen for event from contentToggleModule and update persona and courses
     */
    window.addEventListener('personaset', e => {
      if (e.detail === 'noATAR') {
        this.persona = 'noATAR'
        this.fulllist = [...this.noAtarCourses]
        this.buildFilterList(this.fulllist)
      } else if (e.detail === 'reviewATAR') {
        this.persona = 'reviewATAR'
        this.fulllist = [...this.noHappyCourses]
        this.buildFilterList(this.fulllist)
      } else {
        this.persona = 'okATAR'
        this.fulllist = [...this.happyCourses]
        this.buildFilterList(this.fulllist)
      }

      this.checkStorage(this.persona)
    })
  },
  methods: {
    async getData () {
      try {
        const urlhappy = fetch('https://www.ecu.edu.au/degrees/shared-content/nested-content/funnelback-json-course-info?meta_e_sand=Undergraduate&meta_f_not=Short&meta_f_not=Entry').then(value => value.json())
        const urlnohappy = fetch('https://www.ecu.edu.au/degrees/shared-content/nested-content/funnelback-json-course-info?meta_e_sand=Undergraduate&meta_f_not=Short').then(value => value.json())
        const urlnoatar = fetch('https://www.ecu.edu.au/degrees/shared-content/nested-content/funnelback-json-course-info-atar').then(value => value.json())

        /**
         * Get all course info from Funnelback
         */
        try {
          const [happy, noHappy, noAtar] = await Promise.all([urlhappy, urlnohappy, urlnoatar])

          /**
           * Save course data to state
           */
          this.noAtarCourses = noAtar.results // No need to remove honours as none are returned
          this.noHappyCourses = this.removeHonours(noHappy.results)
          this.happyCourses = this.removeHonours(happy.results)

          /**
           * Update list according to persona
           */
          switch (this.persona) {
            case 'noATAR':
              this.fulllist = [...this.noAtarCourses]
              break
            case 'reviewATAR':
              this.fulllist = [...this.noHappyCourses]
              break
            default:
              this.fulllist = [...this.happyCourses]
          }

          this.loading = false
          this.buildFilterList(this.fulllist)
          this.checkStorage(this.persona)
        } catch (err) {
          console.error(err)
        }
      } catch (err) {
        console.error(err)
      }
    },
    removeHonours (courses) {
      return courses.filter(course => {
        return course.courseType !== 'Honours (Undergraduate)' || course.studyAreasCode.includes('eng_tech')
      })
    },
    buildFilterList (courses) {
      const temp = []
      for (const course of courses) {
        if (course.atar !== 'empty') {
          if (course.courseTitle !== 'empty') {
            temp.push({ text: course.courseTitle, type: 'Course' })
          }

          if (course.studyAreas.indexOf('empty') === -1) {
            // temp = [...temp, ...course.studyAreas] // flatten array and add to temp array
            for (const area of course.studyAreas) {
              temp.push({ text: area, type: 'Study Area' })
            }
          }

          if (course.disciplines.indexOf('empty') === -1) {
            // temp = [...temp, ...course.disciplines] // flatten array and add to temp array
            for (const disc of course.disciplines) {
              temp.push({ text: disc, type: 'Study Interest' })
            }
          }
        }
      }

      // this.filterlist = [...new Set(temp)] // remove all duplicates from array
      this.filterlist = [...new Map(temp.map((item) => [item.text, item])).values()]
      console.log(this.filterlist)
    },
    applicantType (atarshow) { // update vars based on user input
      this.showatar = atarshow
      this.showcourses = true

      if (!this.firsttime) { // update if course list has been displayed
        console.log('call update list')
        this.updateList()
      }
    },
    toggleDrop () {
      if (this.aria) {
        this.aria = false
        this.dropclass = ''
      } else {
        this.aria = true
        this.dropclass = 'dropdownMenu--open'
      }
    },
    handleClickOutside (evt) {
      console.log(this.$refs.dropdown)
      if (!this.$refs.dropdown.contains(evt.target)) {
        this.aria = false
        this.dropclass = ''
      }
    },
    reset () {
      this.atarval = null
      this.searchval = ''
      this.$refs.search.reset()
      this.showintro = true
      this.firsttime = true
      this.clist = []
    },
    searchVal (val) { // get atar val from selector component and call update
      this.searchval = val
      this.updateList()
    },
    isNumber: function ($event) { // restrict input to numbers only
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      let validCode = false

      /**
       * 8 is backspace 9 is tab and 13 is enter 37 and 38 are arrows and 190 is the period key
       */
      if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105) || keyCode === 8 || keyCode === 9 || keyCode === 13 || keyCode === 37 || keyCode === 39 || keyCode === 190) {
        validCode = true
      }

      if(!validCode) {
        $event.preventDefault()
      }
    },
    updateList () {
      this.firsttime = false
      this.showintro = false
      this.clist = this.fulllist

      // filter returned JSON, check if atar is not empty and if selected val is larger than returned atar val
      if (this.persona === 'okATAR' || this.persona === 'reviewATAR') {
        this.clist = this.fulllist.filter((el) => {
          if (parseInt(el.atar) <= parseInt(this.atarval) || el.atar === '') {
            return true
          }

          return false
        })

        if (this.atarval === '' || this.atarval === null) {
          this.disabled = true
        } else {
          this.disabled = false
        }
      }

      // search course list for title studyarea and disciplines that match user input
      if (this.searchval !== '') {
        this.clist = this.clist.filter((el) => {
          if (el.courseTitle.toLowerCase().includes(this.searchval.toLowerCase())) {
            return true
          }

          if (el.studyAreas.join('').toLowerCase().includes(this.searchval.toLowerCase())) {
            return true
          }

          if (el.disciplines.join('').toLowerCase().includes(this.searchval.toLowerCase())) {
            return true
          }

          return false
        })
      }

      console.log(this.clist)
    },
    checkStorage (persona) {
      if (persona === 'noATAR') {
        this.applicantType(false)
        this.disabled = false
      } else {
        this.applicantType(true)
      }
    },
    getUrlVars () {
      const vars = {}
      window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value
      })
      return vars
    }
  }
}
</script>

<style lang="scss">

</style>
